<template>
  <!-- for new record set :create-mode="true" -->
  <complex-activity
      :save-enabled="false"
      :create-mode="false"
      :fluid-bottom-line="false"
  >

    <!-- Tab 1 with simple data -->
    <activity-tab title="Record info">
      <simple-activity :toolbox="toolbox">
        <div style="padding-left: 15px; padding-right: 15px; padding-top: 15px;">
          <b-container class="pt-3 px-0 border-bottom ">
            <b-row v-for="infoRow in info" :key="infoRow.title" class="border-top border-left border-right" no-gutters>
              <b-col class="border-right cols-6 bg-light p-2">
                {{ infoRow.title }}
              </b-col>
              <b-col class="cols-6 p-2">
                <a v-html="infoRow.val"></a>
              </b-col>
            </b-row>
          </b-container>
        </div>
      </simple-activity>
    </activity-tab>


    <!-- Tab 2 with record edit -->
    <!--    <activity-tab title = "API Samples" icon = "user">-->
    <!--      <simple-activity :show-header="false">-->
    <!--        <b-container class="pt-1 px-2" fluid="true">-->
    <!--          <b-row no-gutters>-->
    <!--            <b-col>-->
    <!--              TEXT on tab2-->
    <!--            </b-col>-->
    <!--          </b-row>-->
    <!--        </b-container>-->
    <!--      </simple-activity>-->

    <!--    </activity-tab>-->

    <!--    <activity-tab title = "REST Samples" icon = "user">-->
    <!--      <simple-activity :show-header="false">-->
    <!--        <b-container class="pt-1 px-2" fluid="true">-->
    <!--          <b-row no-gutters>-->
    <!--            <b-col>-->
    <!--              TEXT on tab2-->
    <!--            </b-col>-->
    <!--          </b-row>-->
    <!--        </b-container>-->
    <!--      </simple-activity>-->
    <!--    </activity-tab>-->

    <!--    <activity-tab title = "Spec" icon = "user">-->
    <!--      <simple-activity :show-header="false">-->
    <!--        <div>-->
    <!--            <prism-editor-->

    <!--                :readonly="true"-->
    <!--                ref="editor"-->
    <!--                class="my-editor"-->
    <!--                v-model="formConfigJSON"-->
    <!--                :highlight="highlighter"-->
    <!--                line-numbers-->

    <!--                :style="'white-space: nowrap; '"-->
    <!--            ></prism-editor>-->
    <!--        </div>-->
    <!--          &lt;!&ndash; CONTENT END&ndash;&gt;-->
    <!--      </simple-activity>-->

    <!--    </activity-tab>-->

    <template v-slot:bottomLine>
    </template>

    <template v-slot:footer>

    </template>
  </complex-activity>
</template>

<script>
import Activity from "@/activity/Activity";
import Perms from "@/server/Perms";
import PermissionsSet from "@/server/PermissionsSet";
import FooterButton from "@/components/navbar/FooterButton";
import SimpleActivity from "@/activity/templates/layouts/SimpleActivity";
import RecordEditActivity from "@/activity/templates/layouts/RecordEditActivity";
import ReachInput from "@/components/inputs/ReachInput";
import ComplexActivity from "@/activity/templates/layouts/ComplexActivity";
import ActivityTab from "@/activity/templates/layouts/tabs/ActivityTab";
import {PrismEditor} from "vue-prism-editor";
import {highlight} from "prismjs/components/prism-core";
import Prismjs from "prismjs";
import VBox from "@/components/VBox.vue";

import 'prismjs/components/prism-json';
import {ToolboxButton} from "@/components/navbar/toolbox/ToolboxButton";
import FormsActions from "@/components/forms/FormsActions";
import CompanyConfigurationFormField from "@/server/com/silkplm/model/plm/CompanyConfigurationFormField";
import {
  checkIfEnabledByOrganizationFormsSettingsForForm,
  checkIfEnabledByOrganizationFormsSettingsForFormField,
  findCompanyConfigurationForm,
  findFieldValueFromCompanyCompanyConfigurationForm
} from "@/components/forms/customizations/plm/EntityEditFormService";

export default {
  name: "ClassInfo",
  components: {
    VBox,
    PrismEditor, ActivityTab, ComplexActivity, ReachInput, RecordEditActivity, SimpleActivity, FooterButton
  },
  permission: Perms.SUPERUSER,

  created() {
    this.parseFormConfigInfo(this.formConfig);
  },

  methods: {
    ...Activity.methods,

    // --------------------------------------
    //   Shared methods
    // --------------------------------------

    getTitle() {
      return "Record Info";
    },
    highlighter(code) {
      return highlight(code, Prismjs.languages.json, 'json'); // languages.<insert language> to return html with markup
//    return highlight(code, dummy);
    },

    collectFormPermissions() {
      this.formPermissions = "";
      if (this.formConfig.readPermissionLabel?.length) {
        this.formPermissions = this.formConfig.readPermissionLabel;
      }
      if (this.formConfig.writePermissionLabel?.length) {
        this.formPermissions += ", " + this.formConfig.writePermissionLabel;
      }
      if (this.formConfig.listPermissionLabel?.length) {
        this.formPermissions += ", " + this.formConfig.writePermissionLabel;
      }
    },
    collectSecuredPermissions() {
      this.securedPermissions = ""
      this.formConfig.securedFields.forEach(field => {
        let isEnable = checkIfEnabledByOrganizationFormsSettingsForFormField(this.formConfig, field);
        if (!isEnable) {
          return;
        }
        let hasAlreadyAnySecuredPermissions = false;
        if (field.readPermissionLabel?.length) {
          this.securedPermissions += field.readPermissionLabel;
          hasAlreadyAnySecuredPermissions = true;
        }
        if (field.writePermissionLabel?.length) {
          if (hasAlreadyAnySecuredPermissions) {
            this.securedPermissions += ", ";
          }
          this.securedPermissions += field.writePermissionLabel;
          hasAlreadyAnySecuredPermissions = true;
        }
        if (field.listPermissionLabel?.length) {
          if (hasAlreadyAnySecuredPermissions) {
            this.securedPermissions += ", ";
          }
          this.securedPermissions += field.writePermissionLabel;
        }
        this.securedPermissions += "<hr>";
      });
    },
    collectInlinesGridPermissions() {
      this.inlinesGridPermissions = ""
      this.formConfig.details.forEach(detailForm => {
        if (detailForm.style !== 'Inline') {
          return;
        }
        let isEnable = checkIfEnabledByOrganizationFormsSettingsForForm(detailForm.formConfig.formId);
        if (!isEnable) {
          return;
        }
        let companyConfigurationForm = findCompanyConfigurationForm(detailForm.formConfig.formId);
        if (companyConfigurationForm) {
          detailForm.formConfig.entityPlural = companyConfigurationForm.formName;
        }
        let hasAlreadyAnySecuredPermissions = false;
        if (detailForm.formConfig.readPermissionLabel?.length) {
          this.inlinesGridPermissions += "<b> " + detailForm.formConfig.entityPlural + ":</b></br>";
          this.inlinesGridPermissions += detailForm.formConfig.readPermissionLabel;
          hasAlreadyAnySecuredPermissions = true;
        }
        if (detailForm.formConfig.writePermissionLabel?.length) {
          if (hasAlreadyAnySecuredPermissions) {
            this.inlinesGridPermissions += ", ";
          } else {
            this.inlinesGridPermissions += "<b> " + detailForm.formConfig.entityPlural + ":</b></br>";
          }
          this.inlinesGridPermissions += detailForm.formConfig.writePermissionLabel;
          hasAlreadyAnySecuredPermissions = true;
        }
        if (detailForm.formConfig.listPermissionLabel?.length) {
          if (hasAlreadyAnySecuredPermissions) {
            this.inlinesGridPermissions += ", ";
          } else {
            this.inlinesGridPermissions += "<b> " + detailForm.formConfig.entityPlural + ":</b></br>";
          }
          this.inlinesGridPermissions += detailForm.formConfig.writePermissionLabel;
        }
        this.inlinesGridPermissions += "<hr>";
      });
    },
    /**
     *
     * @param formConfig {FormConfig}
     */
    parseFormConfigInfo(formConfig) {
      this.collectFormPermissions();
      this.collectSecuredPermissions();
      this.collectInlinesGridPermissions();
      this.info = [
        {title: $tr('classInfo.className', 'Class Name'), val: formConfig.entityName},
        {title: $tr('classInfo.canonicalName', 'Canonical class name'), val: formConfig.formClassLong},
        {title: $tr('classInfo.formPermissions', 'Form Permissions: '), val: this.formPermissions},
        {
          title: $tr('classInfo.formFieldsSecuredPermissions', 'Form Fields Secured Permissions: '),
          val: this.securedPermissions
        },
        {
          title: $tr('classInfo.detailInlinesFormPermissions', 'Detail Inlines Form Permissions: '),
          val: this.inlinesGridPermissions
        },
      ]
    },

    async showFieldsConfiguration() {
      let formConfiguration = await Rpc.plm.services.CompanyConfigurationService.findSettingsForForm(this.formConfig.formId);
      let result = await FormsActions.showList(CompanyConfigurationFormField, {
            filter: {
              filterSpecs: [
                {
                  fieldName: "companyConfigurationFormId",
                  fieldLabel: "Company Configuration Form",
                  filterSpec: {
                    idValues: [formConfiguration.id],
                    mergeTree: false,
                  }
                }
              ],
            },
            showAdd: false,
          }
      );
    }

  },
  props: {
    formConfig: {default: null},
    extensionConfig: {default: null},
  },
  data: function () {
    let toolbox = [];
    let exportContractButton = new ToolboxButton().withIcon("wrench").withLabel($tr("configurationOfForm", "Configuration of Form Fields"))
        .withAction((btn) => this.showFieldsConfiguration());
    toolbox.push(exportContractButton);
    return {
      toolbox: [...toolbox],
      info: [],
      permissions: new PermissionsSet(),
    }
  }
}
</script>
